import { InputHTMLAttributes, DetailedHTMLProps, useState } from "react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ITextInputHookForm
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  secondDiv?: string;
  label?: string;
  register?: UseFormRegisterReturn;
  required?: boolean;
  onChange?: any;
  placeholder?: any;
}
const TextInputLabelCarrierForm: React.FC<ITextInputHookForm> = ({
  type = "text",
  className = "border border-gray-300 col-span-2",
  secondDiv = "grid grid-cols-1 md:grid-cols-2",
  disabled = false,
  required = false,
  register,
  label,
  pattern,
  title,
  min,
  maxLength,
  onChange,
  placeholder,
  ...props
}) => {
  return (
    <div className="space-y-1 w-full text-xs">
      {label && (
        <label className="flex space-x-1 justify-start whitespace-nowrap expandedLabel fontExpand">
          {label}
        </label>
      )}

      <div
        className={`${
          required
            ? `flex items-center gap-1`
            : `${secondDiv} w-full items-center gap-1`
        }`}
      >
        {required && <div className="text-red-500 pr-0.5 font-bold">*</div>}
        <input
          className={`${className}  block w-full px-1 py-1 rounded-sm bg-white text-login bg-clip-padding 
          leading-normal outline-none focus:ring-septenary focus:border-septenary ${
            disabled && "opacity-50"
          }`}
          {...register}
          disabled={disabled}
          type={type}
          pattern={pattern}
          title={title}
          min={min}
          maxLength={maxLength}
          onChange={onChange}
          placeholder={placeholder}
          {...props}
        />
      </div>
    </div>
  );
};
export default TextInputLabelCarrierForm;
